import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import bg from './locales/bg.json';
import de from './locales/de.json';
import sr from './locales/sr.json';
import ru from './locales/ru.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    //lng: 'bg',

    fallbackLng: 'bg',

    supportedLngs: ['en', 'bg', 'de', 'sr', 'ru'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },

    resources: {
      en: { translation: en },
      bg: { translation: bg },
      de: { translation: de },
      sr: { translation: sr },
      ru: { translation: ru },
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;